import Logo from './components/Logo';
import Button, { ButtonLogout, ButtonLogin } from './components/Button';
import PageLoading from './components/PageLoading';
import LoadingIndicator from './components/LoadingIndicator';
import Dialog from './components/Dialog';
import Navbar from './components/Navbar';
import GeneralError from './components/GeneralError';
import InputAuthKey from './components/InputAuthKey';
import LoginByPasswordInputAuthKeyV2 from './components/LoginByPasswordInputAuthKeyV2';
import SignupInputAuthKey from './components/SignupInputAuthKey';
import InputResetPasswordKey from './components/InputResetPasswordKey';
import SignupByOTPForm from './components/SignupByOTPForm';
import LoginByPasswordForm from './components/LoginByPasswordForm';
import VersionNumber from './components/VersionNumber';
import AuthBackgroundContainer from './components/AuthBackgroundContainer';
import SignupByOtpTip from './components/SignupByOtpTip';
import OneCredentialMigrateSuccessImage from './components/OneCredentialMigrateSuccessImage';
import SignupTermsOfService from './components/SignupTermsOfService';
import LoginByPasswordFooter from './components/LoginByPasswordFooter';
import SignupRequireAuthKeyHeader from './components/SignupByOtpSkeleton/RequirePhone/Header';
import SignupRequireAuthKeyContent from './components/SignupByOtpSkeleton/RequirePhone/Content';
import SignupRequireAuthKeyFooter from './components/SignupByOtpSkeleton/RequirePhone/Footer';
import OneCredentialDelinkLogo from './components/OneCredentialDelinkLogo';
import OneCredentialDelinkInputAuthKey from './components/OneCredentialDelinkInputAuthKey';

const SignupRequireAuthKey = {
  Header: SignupRequireAuthKeyHeader,
  Content: SignupRequireAuthKeyContent,
  Footer: SignupRequireAuthKeyFooter,
};

import { Header as SignupOneCredentialOptionalRequireAuthKeyHeader } from './components/SignupOneCredentialOptionalSkeleton/Header';
import { Content as SignupOneCredentialOptionalRequireAuthKeyContent } from './components/SignupOneCredentialOptionalSkeleton/Content';
import { Footer as SignupOneCredentialOptionalRequireAuthKeyFooter } from './components/SignupOneCredentialOptionalSkeleton/Footer';

import LoginByPasswordRequirePasswordHeader from './components/LoginByPasswordSkeleton/RequirePassword/Header';
import LoginByPasswordRequirePasswordContent from './components/LoginByPasswordSkeleton/RequirePassword/Content';
import LoginByPasswordRequirePasswordFooter from './components/LoginByPasswordSkeleton/RequirePassword/Footer';

import { Header as LoginByOtpOneCredentialOptionalRequireAuthKeyHeader } from './components/LoginByOtpOneCredentialOptionalSkeleton/RequireAuthKey/Header';
import { Content as LoginByOtpOneCredentialOptionalRequireAuthKeyContent } from './components/LoginByOtpOneCredentialOptionalSkeleton/RequireAuthKey/Content';
import { Footer as LoginByOtpOneCredentialOptionalRequireAuthKeyFooter } from './components/LoginByOtpOneCredentialOptionalSkeleton/RequireAuthKey/Footer';

import LoginByPasswordOneCredentialOptionalRequirePasswordHeader from './components/LoginByPasswordOneCredentialOptionalSkeleton/RequirePassword/Header';
import LoginByPasswordOneCredentialOptionalRequirePasswordContent from './components/LoginByPasswordOneCredentialOptionalSkeleton/RequirePassword/Content';
import LoginByPasswordOneCredentialOptionalRequirePasswordFooter from './components/LoginByPasswordOneCredentialOptionalSkeleton/RequirePassword/Footer';

const SignupByOtpOneCredentialOptionalRequireAuthKey = {
  Header: SignupOneCredentialOptionalRequireAuthKeyHeader,
  Content: SignupOneCredentialOptionalRequireAuthKeyContent,
  Footer: SignupOneCredentialOptionalRequireAuthKeyFooter,
};

const LoginByPasswordRequirePassword = {
  Header: LoginByPasswordRequirePasswordHeader,
  Content: LoginByPasswordRequirePasswordContent,
  Footer: LoginByPasswordRequirePasswordFooter,
};

const LoginByOtpOneCredentialOptionalRequireAuthKey = {
  Header: LoginByOtpOneCredentialOptionalRequireAuthKeyHeader,
  Content: LoginByOtpOneCredentialOptionalRequireAuthKeyContent,
  Footer: LoginByOtpOneCredentialOptionalRequireAuthKeyFooter,
};

import LoginTermsOfService from './components/LoginTermsOfService';
import OneCredentialDelinkSuccessImage from './components/OneCredentialDelinkSuccessImage';

const LoginByPasswordOneCredentialOptionalRequirePassword = {
  Header: LoginByPasswordOneCredentialOptionalRequirePasswordHeader,
  Content: LoginByPasswordOneCredentialOptionalRequirePasswordContent,
  Footer: LoginByPasswordOneCredentialOptionalRequirePasswordFooter,
};

export * from './components/NavbarHelpButton';

export {
  Logo,
  Logo as LogoOneCredentialFlow,
  Button,
  ButtonLogout,
  ButtonLogin,
  Dialog,
  Navbar,
  PageLoading,
  LoadingIndicator,
  GeneralError,
  InputAuthKey,
  LoginByPasswordInputAuthKeyV2,
  SignupInputAuthKey,
  InputResetPasswordKey,
  SignupByOTPForm,
  LoginByPasswordForm,
  VersionNumber,
  AuthBackgroundContainer,
  SignupByOtpTip,
  Logo as SignupV2AlreadyRegisteredLogo,
  Logo as SignupAlreadyRegisteredLogo,
  OneCredentialMigrateSuccessImage,
  SignupTermsOfService,
  LoginByPasswordFooter,
  SignupByOtpOneCredentialOptionalRequireAuthKey,
  SignupRequireAuthKey,
  LoginByPasswordRequirePassword,
  LoginByOtpOneCredentialOptionalRequireAuthKey,
  LoginTermsOfService,
  OneCredentialDelinkLogo,
  OneCredentialDelinkSuccessImage,
  LoginByPasswordOneCredentialOptionalRequirePassword,
  OneCredentialDelinkInputAuthKey,
};

export {
  ResponsiveImage,
  NotFound,
  AccountPasswordForm,
  AuthPasswordForm,
  AccountPasswordRules,
  AuthPasswordRules,
  InputPassword,
  InputCheckbox,
  AccessibleSpan,
  InputLoginByOtpAuthKey,
  Toast,
  Tip,
  OneCredentialMigrateOverviewBackgroundImage,
  LoginLink,
  AccountPageHelpFooter,
  LoginInputPassword,
  SignupInputAuthKeyV2,
  DesktopNavbar,
  LinkingNoticeImage,
  SignupContactUsMessage,
  SignupAlreadyRegisteredLoginButton,
  DialogWithButtonConfigs,
  EnforceSetNewPasswordDialog,
  LanguageSelectorDropdown,
  SignupLink,
  ResetPasswordLinkContent,
  ThirdPartyAuthenticationComponents,
} from '@shopee-user/shared-customization-ui';
export { LoginByPasswordSubmitButton } from '@shopee-user/shared-customization-ui';
export { default as AlternativeLoginEntrance } from './components/AlternativeLoginEntrance';
